import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  output,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { DurationColumnFormat } from '@blaze-shared/api-contracts-domain';
import {
  durationInputTransform,
  durationPaste,
  formatDuration,
  formatDurationForSaving,
} from '@blaze-shared/shared-feature';

import { type InlineEditorConfig } from '../base-editor/inline-editor.types';

@UntilDestroy()
@Component({
  selector: 'be-duration-editor',
  templateUrl: './duration-editor.component.html',
  styleUrls: ['./duration-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class TableDurationEditorComponent implements AfterViewInit {
  valueChange = output<string | null>();

  @Input() config?: InlineEditorConfig;
  @Input() value: string | number | undefined;

  @ViewChild('stringInput') stringInput!: ElementRef<HTMLInputElement>;

  durationFormControl = new UntypedFormControl('');
  durationInputTransformFn = (event: InputEvent, formControl: UntypedFormControl): void => {
    durationInputTransform(event, formControl, this.durationFormat);
  };
  durationInputPasteFn = (event: ClipboardEvent, formControl: UntypedFormControl): void => {
    durationPaste(event, formControl, this.durationFormat);
  };

  get durationFormat(): DurationColumnFormat {
    return this.config?.columnSchema?.format?.durationFormat || 'h:mm';
  }

  constructor() {
    this.durationFormControl.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
      if (value === '') {
        return this.emitValue(null);
      }
      this.emitValue(formatDurationForSaving(value, this.durationFormat));
    });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.stringInput.nativeElement.focus();
      this.stringInput.nativeElement.select();
    });
    this.initialFormat();
  }

  private emitValue(value: string | null): void {
    this.valueChange.emit(value);
  }

  private initialFormat(value = this.value, config = this.config): void {
    if (!config) {
      return;
    }

    this.durationFormControl.patchValue(formatDuration(value, this.durationFormat));
  }
}
